import React, { useReducer, useContext } from "react";
import { enterpriseReducer as reducer } from "../reducers/enterpriseReducer";
import { enterpriseActions as actions } from "../actions/enterpriseActions";

const initialValue = {
  enterrpises: null,
};

const enterpriseContext = React.createContext();

const EnterpriseContext = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialValue);

  return (
    <enterpriseContext.Provider value={{ state, dispatch, actions }}>
      {children}
    </enterpriseContext.Provider>
  );
};

export const useEnterpriseContext = () => React.useContext(enterpriseContext);
export default EnterpriseContext;
